<template>
    <footer class="position-relative z-index-10">
        <!-- Copyright section of the footer-->
        <div class=" font-weight-light bg-gray-800 text-gray-300">
            <div class="container">
                <div class="row align-items-center" style="height: 47px">
                    <div class="col-md-6 text-center text-md-left">
                        <p class="text-sm mb-md-0">{{ t('message["Powered by SQRmenu.com"]', 'Powered by SQRmenu.com') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import language from '../mixins/translate'
export default {
    mixins: [language]
}
</script>